import DialogImport from './src/dialogimport.vue';

DialogImport.install = function (Vue) {
    Vue.component(DialogImport.name, DialogImport);
};

export default DialogImport;